// Module
var code = `<div class="modal-dialog" role="document">
    <div class="modal-content force-text-wrap-word" tabindex="-1">
        <div class="modal-header">
            <button type="button" class="close" data-bind="click: close" aria-hidden="true">
                <i class="icon-cancel"></i>
            </button>
            <div data-bind="with: alert">
                <h3 class="modal-title" id="myModalLabel" data-bind="text: title, attr:{ class: 'modal-title ' + headerClass() }"></h3>
                <div class="notification-time" data-bind="text: displayDate().format('LLL')"></div>
            </div>
        </div>
        <div class="modal-body">
            <h3 data-bind="html: alert.message"></h3>
            <div class="modal-details" data-bind="with: alert.details">
                <div class="details-item">
                    <div class="row">
                        <div class="col-md-4 text-right">Build Type</div>
                        <div class="col-md-8 details-value" data-bind="text: VersionInfo.BuildType"></div>
                    </div>
                </div>
                <div class="details-item">
                    <div class="row">
                        <div class="col-md-4 text-right">Release date</div>
                        <div class="col-md-8 details-value" data-bind="text: \$parent.releaseDate"></div>
                    </div>
                </div>
            </div>
            <div class="text-center">
                <a target="_blank" class="btn btn-primary" href="https://ravendb.net/downloads">
                    <i class="icon-export"></i> <span>Download</span>
                </a>
                <a target="_blank" class="btn btn-info" data-bind="attr: { href: 'https://ravendb.net/whats-new?buildNumber=' + alert.details().VersionInfo.BuildNumber }">
                    <i class="icon-info"></i> <span>What's New</span>
                </a>
            </div>
        </div>
        <div class="modal-footer" data-bind="compose: \$root.footerPartialView">
        </div>
    </div>
</div>
`;
// Exports
export default code;